{
  "localeInternationalCountryCode": "PL",
  "PhoneInput": {
    "placeholder": "Wprowadź numer telefonu",
    "emptyDisplay": "-"
  },
  "CountryInput": {
    "placeholder": "Wybierz kraj",
    "emptyCountries": "Nie znaleziono krajów",
    "emptyDisplay": "-",
    "groupCommon": "Popularne",
    "groupAllCountries": "Wszystkie kraje"
  }
}
